/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import DownloadProductNoticeMutation from '../graphql/mutations/DownloadProductNoticeMutation.js';

export const useDownloadProductNoticeMutation = () => {
  return useCommitMutation(DownloadProductNoticeMutation, { dataProp: 'downloadProductNotice_M_simulation_product' });
};

export default useDownloadProductNoticeMutation;
